import { render, staticRenderFns } from "./Stud.vue?vue&type=template&id=2410a6f8&scoped=true&"
import script from "./Stud.vue?vue&type=script&lang=js&"
export * from "./Stud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410a6f8",
  null
  
)

export default component.exports